import styled from 'styled-components'

export const StyledSeparator = styled.hr`
  width: 100%;
  height: 0;
  border-top-color: ${({ theme }) => theme.colors.border};
  margin: 1rem 0;
`
